import { Component, Input } from '@angular/core';
import { CoreService } from 'src/app/services/core.service';

@Component({
  selector: 'app-branding',
  imports: [],
  template: `
    <a href="/" [class]="['logodark', class]">
      <img src="./assets/images/logos/gfli-light-logo.webp" [class]="class" class="mx-auto" alt="logo" width="190" />
    </a>

    <a href="/" [class]="['logolight', class]">
      <img src="./assets/images/logos/gfli-dark-logo.webp" [class]="class" class="mx-auto" alt="logo" width="190" />
    </a>
  `
})
export class BrandingComponent {
  @Input() class?: string;
  options = this.settings.getOptions();
  constructor(private settings: CoreService) {}
}
